import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Menu from "../components/Menu";
import axios from "axios";
import moment from "moment";
import { AuthContext } from "../context/authContext";

const Single = () => {
  const [post, setPost] = useState({});
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [likeCount, setLikeCount] = useState(0);
  const [likedByUser, setLikedByUser] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const postId = location.pathname.split("/")[2];

  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`/api/posts/${postId}`);
        setPost(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [postId]);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const res = await axios.get(`/api/comments/${postId}`);
        setComments(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchComments();
  }, [postId]);

  useEffect(() => {
    const fetchLikes = async () => {
      try {
        const res = await axios.get(`/api/likes/${postId}`);
        setLikeCount(res.data.count);
        setLikedByUser(res.data.likedByUser);
      } catch (err) {
        console.log(err);
      }
    };
    fetchLikes();
  }, [postId]);

  const handleDelete = async () => {
    try {
      await axios.delete(`/api/posts/${postId}`);
      navigate("/");
    } catch (err) {
      console.log(err);
    }
  };

  const handleLike = async () => {
    if (!currentUser) {
      navigate("/login");
      return;
    }
    try {
      await axios.post("/api/likes", { postId });
      setLikedByUser(!likedByUser);
      setLikeCount(likedByUser ? likeCount - 1 : likeCount + 1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      navigate("/login");
      return;
    }
    if (!commentText.trim()) return;

    try {
      await axios.post("/api/comments", { postId, text: commentText });
      setCommentText("");
      const res = await axios.get(`/api/comments/${postId}`);
      setComments(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent;
  };

  return (
    <div className="single">
      <div className="content">
       <img src={`/upload/${post?.img}`} alt="post cover" />
        <div className="user">
          {post.userImg && <img src={post.userImg} alt="user" />}
          <div className="info">
            <span>{post.username}</span>
            <p>Posted {moment(post.date).fromNow()}</p>
          </div>
          {currentUser?.username === post.username && (
<div className="edit">
              <Link to={`/write?edit=2`} state={post} className="edit-btn">
                edit
              </Link>
              <span onClick={handleDelete} className="delete-btn">
                delete
              </span>
            </div>
          )}
        </div>

<h1>{post.title}</h1>
        <div className="post-body" dangerouslySetInnerHTML={{ __html: post.desc }} />

        <div className="likes">
          <button onClick={handleLike} className={likedByUser ? "liked" : ""}>
            {likedByUser ? "★ Liked!" : "☆ Like"}
          </button>
          <span>{likeCount} {likeCount === 1 ? "like" : "likes"}</span>
        </div>

        <div className="comments">
          <h2>Comments ({comments.length})</h2>

          {currentUser ? (
            <form onSubmit={handleCommentSubmit} className="comment-form">
              <textarea
                placeholder="Say something nice..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />
              <button type="submit">Post comment</button>
            </form>
          ) : (
            <p className="login-prompt">
              <Link to="/login">Log in</Link> to like or comment!
            </p>
          )}

          <div className="comment-list">
            {comments.map((c) => (
              <div className="comment" key={c.id}>
                <span className="comment-username">{c.username}</span>
                <span className="comment-date">{moment(c.date).fromNow()}</span>
                <p>{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Menu cat={post.cat} />
    </div>
  );
};

export default Single;
